// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__34tn_","video-box":"Video_video-box__2bKQG","video-rate-control":"Video_video-rate-control__1CWb3","video-close":"Video_video-close__13usv"};